import React, { Component } from 'react';

import ModalBase from './ModalBase';
import EdbButton from './EdbButton'
class ModalStepBase extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentStep: 0,
            maxOpenStep: 0,
            stepsContent: [
                // {
                //     title: "Step1 fds fds fds fds f ",
                //     content: (<div>Conteúdo Step 1 <input/></div>)
                // },
                // {
                //     title: "Step2 sdf dsf ",
                //     content: (<div>Conteúdo Step 2 <input/></div>)
                // },
                // {
                //     title: "Step3",
                //     content: (<div>Conteúdo Step 3</div>)
                // }
            ]
        }

        this.changeToStep = this.changeToStep.bind(this);
        this.onClickNext = this.onClickNext.bind(this);
        this.onClickPrevious = this.onClickPrevious.bind(this);
    }

    componentDidUpdate(prevProps) {
        // console.log('prevProps.id',prevProps.id, 'this.props.id', this.props.id);
        //Se trocou de id, reseta para o estado inicial

        // Don't forget to compare props, or you’ll cause an infinite loop
        if (this.props.id !== prevProps.id) {

            this.setState({ currentStep: 0, maxOpenStep: 0, stepsContent: [] });
        }
    }

    changeToStep(step) {
        // console.log('changeToStep', step);
        var oldStep = this.state.currentStep;
        var newStep = step;

        if (this.props.onChangingStep) {
            //Executando alguma regra para ver se pode trocar de passo, caso contrário não faz nada
            var result = this.props.onChangingStep(newStep, oldStep);
            if (result === false) { return; }
        }

        //if(step <= this.state.maxOpenStep){
        this.setState({ currentStep: newStep });
        //}

        if (this.props.onChangeStep) {
            this.props.onChangeStep(newStep, oldStep);
        }
    }

    onClickNext() {
        // console.log('onClickNext');
        var oldStep = this.state.currentStep;
        var newStep = this.state.currentStep + 1;

        if (newStep < this.props.stepsContent.length) {

            if (this.props.onChangingStep) {
                //Executando alguma regra para ver se pode trocar de passo, caso contrário não faz nada
                var result = this.props.onChangingStep(newStep, oldStep);
                if (result === false) { return; }
            }


            this.setState({
                currentStep: newStep,
                maxOpenStep: Math.max(this.state.maxOpenStep, newStep)
            });

            if (this.props.onChangeStep) {
                this.props.onChangeStep(newStep, oldStep);
            }
        }

    }

    onClickPrevious() {
        // console.log('onClickPrevious');
        var oldStep = this.state.currentStep;
        var newStep = this.state.currentStep - 1;

        if (newStep >= 0) {

            if (this.props.onChangingStep) {
                //Executando alguma regra para ver se pode trocar de passo, caso contrário não faz nada
                var result = this.props.onChangingStep(newStep, oldStep);
                if (result === false) { return; }
            }


            this.setState({
                currentStep: newStep
            });

            if (this.props.onChangeStep) {
                this.props.onChangeStep(newStep, oldStep);
            }
        }
    }

    getStepColor(step) {
        if (step === this.state.currentStep) {
            return " adap-green ";
        }
        // else if(step <= this.state.maxOpenStep){
        //     return " adap-gray ";
        // }
        else {
            return " adap-dark-gray ";
        }
    }

    getTitle(step) {
        if (step === this.state.currentStep) {
            return "Passo 1: Configurar o simulado";
        }
        // else if(step <= this.state.maxOpenStep){
        //     return " adap-gray ";
        // }
        else {
            return "Passo 2: Selecionar Turmas";
        }
    }

    getStepNotAllowed(step) {
        // return (step > this.state.maxOpenStep) ? " edb-cursor-not-allowed " : "";
    }

    render() {
        return (
            <ModalBase {...this.props} content={
                <>
                    <div className="edb-cell adap-modal-steps edb-center edb-border-right edb-padding-top">
                        {this.props.stepsContent.map((item, index) =>
                            <div className={"adap-modal-step edb-margin-bottom " + this.getStepNotAllowed(index)}
                                key={`step-modal-idx-${index}`}
                                onClick={() => this.changeToStep(index)} >

                                <div className={"edb-circle adap-modal-step-index" + this.getStepColor(index)} title={this.getTitle(index)}>{index + 1}</div>
                                {/* <div class={"edb-btn edb-large edb-circle" + this.getStepColor(index) + this.getStepNotAllowed(index)}>{index+1}</div> */}
                                <div className="edb-line-height-small edb-margin-small-top edb-container adap-modal-step-title">{item.title}</div>
                            </div>
                        )}
                    </div>
                    <div className="edb-cell adap-modal-step-content">
                        {this.props.stepsContent.map((item, index) =>
                            <div className="adap-modal-step-content-wraper" key={`step-modal-content-${index}`} style={index === this.state.currentStep ? {} : { display: "none" }}>
                                {item.content}
                            </div>
                        )}

                        {this.state.currentStep > 0 &&
                            <button className="edb-button edb-round adap-gray edb-display-bottomleft edb-margin-large-left edb-margin-large-bottom adap-modal-step-btn-previous" onClick={this.onClickPrevious}>Anterior</button>
                        }

                        {(this.state.currentStep === this.props.stepsContent.length - 1) ?
                            (!this.props.esconderFinalizar && <EdbButton className="edb-button edb-round adap-green edb-display-bottomright edb-margin-large-right edb-margin-large-bottom adap-modal-step-btn-finish"
                                content="Finalizar"
                                loadingContent="Finalizando, por favor aguarde..."
                                loading={this.props.loadingFinalizar}
                                onClick={this.props.onClickFinish} />)
                            :
                            <button className="edb-button edb-round adap-green edb-display-bottomright edb-margin-large-right edb-margin-large-bottom adap-modal-step-btn-next" onClick={this.onClickNext}>Próximo</button>
                        }

                    </div>
                </>
            } />
        );
    }
}

export default ModalStepBase;